const MonitorWrapper = () => import('src/views/Monitor/MonitorWrapper.vue')

const routes = [
  {
    path: '/monitor/view',
    component: MonitorWrapper,
    name: 'monitor',
    meta: {
      isPublic: true,
      enableSwHotReload: true,
      middleware: null
    }
  }
]

export default routes
